module.exports = __webpack_public_path__ + "img/freestyle-grid-img.49aee715.webp";